// src/app/redux/reducers/niveauCriticiteReducer.js

import {
    FETCH_NIVEAU_CRITICITE_REQUEST, FETCH_NIVEAU_CRITICITE_SUCCESS, FETCH_NIVEAU_CRITICITE_FAIL,
    CREATE_NIVEAU_CRITICITE_REQUEST, CREATE_NIVEAU_CRITICITE_SUCCESS, CREATE_NIVEAU_CRITICITE_FAIL,
    UPDATE_NIVEAU_CRITICITE_REQUEST, UPDATE_NIVEAU_CRITICITE_SUCCESS, UPDATE_NIVEAU_CRITICITE_FAIL,
    DELETE_NIVEAU_CRITICITE_REQUEST, DELETE_NIVEAU_CRITICITE_SUCCESS, DELETE_NIVEAU_CRITICITE_FAIL,
    SET_NIVEAU_CRITICITE_LOADING, CLEAR_NIVEAU_CRITICITE_ERROR,
} from "../actions/niveauCriticiteActions";

const initialState = {
    niveauCriticites: [],
    loading: false,
    error: null,
};

export default function niveauCriticiteReducer(state = initialState, action) {
    switch (action.type) {

        case SET_NIVEAU_CRITICITE_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_NIVEAU_CRITICITE_ERROR:
            return { ...state, error: null };

        case FETCH_NIVEAU_CRITICITE_REQUEST:
        case CREATE_NIVEAU_CRITICITE_REQUEST:
        case UPDATE_NIVEAU_CRITICITE_REQUEST:
        case DELETE_NIVEAU_CRITICITE_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_NIVEAU_CRITICITE_SUCCESS:
            return { ...state, loading: false, niveauCriticites: action.payload || [] };

        case CREATE_NIVEAU_CRITICITE_SUCCESS:
            return { ...state, loading: false, niveauCriticites: [...state.niveauCriticites, action.payload] };

        case UPDATE_NIVEAU_CRITICITE_SUCCESS:
            return {
                ...state,
                loading: false,
                niveauCriticites: state.niveauCriticites.map((n) =>
                    n.id === action.payload.id ? action.payload : n
                ),
            };

        case DELETE_NIVEAU_CRITICITE_SUCCESS:
            return {
                ...state,
                loading: false,
                niveauCriticites: state.niveauCriticites.filter((n) => n.id !== action.payload.id),
            };

        case FETCH_NIVEAU_CRITICITE_FAIL:
        case CREATE_NIVEAU_CRITICITE_FAIL:
        case UPDATE_NIVEAU_CRITICITE_FAIL:
        case DELETE_NIVEAU_CRITICITE_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}
